export const THEMES = {
  SYSTEM_THEME: 'SYSTEM_THEME',
  LIGHT: 'LIGHT',
  DARK: 'DARK',
};

// Interface languages — endonyms (not translated) + flags. Shared by LanguagePopover and SettingsModal.
export const LANGUAGE_OPTIONS = [
  { value: 'en', label: 'English', icon: '/static/icons/uk_flag.svg' },
  { value: 'sv', label: 'Svenska', icon: '/static/icons/se_flag.svg' },
  { value: 'nb', label: 'Norsk', icon: '/static/icons/no_flag.svg' },
];

// DOM id of the app's scroll container (`DashboardLayoutContent`). The dashboard shell
// scrolls this element, not the window, so scroll resets have to target it directly.
export const APP_SCROLL_CONTAINER_ID = 'app-scroll-container';
